import { defineMessages } from 'react-intl';
export const commonSearchBlockMessages = defineMessages({
  clearFilter: {
    id: 'clearFilter',
    defaultMessage: 'Clear {filterName} filter',
  },
  clearAllFilters: {
    id: 'clearAllFilters',
    defaultMessage: 'Clear all filters',
  },
  DateRangeFacetFilterListEntryDal: {
    id: 'DateRangeFacetFilterListEntryDal',
    defaultMessage: 'Dal {start}',
  },
  DateRangeFacetFilterListEntryAl: {
    id: 'DateRangeFacetFilterListEntryAl',
    defaultMessage: 'Al {end}',
  },
  DateRangeFacetFilterListEntryDalAl: {
    id: 'DateRangeFacetFilterListEntryDalAl',
    defaultMessage: 'Dal {start} al {end}',
  },
  currentFilters: {
    id: 'Current filters applied',
    defaultMessage: 'Current filters applied',
  },
  clearFilters: {
    id: 'Clear filters',
    defaultMessage: 'Clear filters',
  },
  searchedFor: {
    id: 'searchedFor',
    defaultMessage: 'Ricerca per: <em>{searchedtext}</em>. ',
  },
  search: {
    id: 'SearchSearchBlock',
    defaultMessage: 'Cerca una parola chiave',
  },
  searchButtonText: {
    id: 'SearchSearchBlockButtonText',
    defaultMessage: 'Search',
  },
  clearSearch: {
    id: 'clearSearch',
    defaultMessage: 'Clear search',
  },
});
